// 19-05-2025
// To handle the actionable pop, confirm click for delete user
import { takeEvery, fork, all, call, put } from "redux-saga/effects";
import { POPUP_CONFIRM } from "./actionTypes";
import { deleteUser } from "../../api/userAPI";
import {  successToast } from "./actions";
import { removeUserIds } from "../users/actions";

function* onPopUpConfirm({ payload: { id, type } }) {
  switch (type) {
    case "DELETE_USER":
      try {
        const { data, message } = yield call(deleteUser, id);
        // yield call(loadUsers);
        yield put(successToast({ title: "Success", message: message }));
        yield put(removeUserIds(id))
        break;
      } catch (e) {
        console.log("Err deleting user");
      }

    default:
      console.log("Unhandled popup type:", type);
  }

}
export function* watchPopUpConfirm() {
  yield takeEvery(POPUP_CONFIRM, onPopUpConfirm);
}

export default function* sharedDataSaga() {
  yield all([fork(watchPopUpConfirm)]);
}
